import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { ErrorsContext } from 'context/Context';
import PropTypes from 'prop-types';
import { selectAuthError } from 'store/auth';
import { selectBalanceError } from 'store/balance';
import { selectCustomersError } from 'store/customer';
import { selectEquipmentError } from 'store/equipment';
import { selectLocationError } from 'store/locations';
import { selectMinerError } from 'store/miner';
import { selectOrderError } from 'store/order';
import { selectPoolError } from 'store/pool';
import { selectProductsError } from 'store/products';
import { selectTenantError } from 'store/tenants';

export const ErrorsProvider = ({ children }) => {
  const [errors, setErrors] = useState([]);

  const authError = useSelector(selectAuthError);
  const balanceError = useSelector(selectBalanceError);
  const customerError = useSelector(selectCustomersError);
  const equipmentError = useSelector(selectEquipmentError);
  const locationError = useSelector(selectLocationError);
  const poolError = useSelector(selectPoolError);
  const tenantError = useSelector(selectTenantError);
  const orderError = useSelector(selectOrderError);
  const minerError = useSelector(selectMinerError);
  const productsError = useSelector(selectProductsError);

  const allErrors = useMemo(
    () =>
      [
        authError,
        balanceError,
        customerError,
        equipmentError,
        locationError,
        poolError,
        tenantError,
        orderError,
        minerError,
        productsError
      ].filter(error => error),
    [
      authError,
      balanceError,
      customerError,
      equipmentError,
      locationError,
      poolError,
      tenantError,
      orderError,
      minerError,
      productsError
    ]
  );

  useEffect(() => {
    if (allErrors.length) {
      setErrors(prevErrors => {
        const combinedErrors = [...prevErrors, ...allErrors];
        return Array.from(new Set(combinedErrors));
      });
    }
  }, [allErrors]);

  return (
    <ErrorsContext.Provider value={{ errors, setErrors }}>
      {children}
    </ErrorsContext.Provider>
  );
};

ErrorsProvider.propTypes = {
  children: PropTypes.node.isRequired
};
